// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1ed2626b","498":"2df5d345","513":"2c4f0f07","684":"3e8dd463","787":"33bf87da"}[chunkId] + ".chunk.js";
};